export default __webpack_public_path__ + "static/media/dcrc5.f263aed7.png";